export default {
  SET_LIST(state, offices) {
    state.list = offices;
  },
  SET_CURRENT_OFFICE(state, office) {
    state.current_office = office;
  },
};
